import { c as _c } from "react/compiler-runtime";
import { useCallback, useState } from 'react';
import type { BREAKPOINTS } from '@/constants';
import { useIsomorphicLayoutEffect } from './useIsomorphicLayoutEffect';

/**
 * @deprecated
 */
export const LEGACY_BREAKPOINTS = {
  MOBILE: '(max-width: 767px)',
  TABLET: '(min-width: 768px) and (max-width: 1023px)',
  DESKTOP: '(min-width: 1024px)'
} as const;
type BreakpointType = (typeof BREAKPOINTS)[keyof typeof BREAKPOINTS];

/**
 * 미디어 쿼리 상태를 추적하는 커스텀 훅
 * @param query - 미디어 쿼리 문자열 또는 미리 정의된 브레이크포인트
 * @param defaultValue - SSR 환경에서 사용할 기본값 (기본값: false)
 * @returns 현재 미디어 쿼리 매치 상태
 */
export const useMediaQuery = (query, t0) => {
  const $ = _c(4);
  const defaultValue = t0 === undefined ? false : t0;
  const [matches, setMatches] = useState(defaultValue);
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = event => {
      setMatches(event.matches);
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const handleChange = t1;
  let t2;
  let t3;
  if ($[1] !== query) {
    t2 = () => {
      if (typeof window === "undefined") {
        return;
      }
      const media = window.matchMedia(query);
      setMatches(media.matches);
      media.addEventListener("change", handleChange);
      return () => media.removeEventListener("change", handleChange);
    };
    t3 = [query, handleChange];
    $[1] = query;
    $[2] = t2;
    $[3] = t3;
  } else {
    t2 = $[2];
    t3 = $[3];
  }
  useIsomorphicLayoutEffect(t2, t3);
  return matches;
};